import { GrafikCercevesi } from "./GrafikCercevesi";
import { olculen, sayiMetni } from "./hesap";
import type { GrafikDegeri, GrafikOrtakProps } from "./tipler";

export interface MiniCubukProps extends GrafikOrtakProps {
  deger: GrafikDegeri;
  oncekiDeger?: GrafikDegeri;
  ustSinir?: number;
  /** Tablo satırı içinde: çerçevenin özet/tablo/klavye öğeleri çizilmez (`GrafikCercevesi`). */
  yalin?: boolean;
}

export function MiniCubuk({
  baslik,
  deger,
  oncekiDeger,
  ustSinir = 100,
  ozet,
  birim = "%",
  bosMesaji,
  yalin = false,
}: MiniCubukProps) {
  const simdiki = olculen(deger);
  const onceki = olculen(oncekiDeger);
  const sinir = olculen(ustSinir);
  const oran = simdiki === null || sinir === null || sinir === 0 ? 0 : Math.min(1, simdiki / sinir);
  const yon =
    simdiki === null || onceki === null
      ? "Yön ölçülmedi"
      : simdiki > onceki
        ? "Artış"
        : simdiki < onceki
          ? "Azalış"
          : "Sabit";
  const ok = yon === "Artış" ? "↑" : yon === "Azalış" ? "↓" : yon === "Sabit" ? "→" : "—";
  const ozetMetni =
    ozet?.trim() ||
    `${baslik}: ${sayiMetni(simdiki, birim)}. ${yon}; önceki değer ${sayiMetni(onceki, birim)}.`;
  return (
    <GrafikCercevesi
      baslik={baslik}
      ozet={ozetMetni}
      bos={simdiki === null}
      bosMesaji={bosMesaji}
      kucuk
      yalin={yalin}
      basliklar={["Değer", "Önceki değer", "Yön", "Üst sınır"]}
      satirlar={[
        {
          anahtar: "deger",
          etiket: baslik,
          hucreler: [
            sayiMetni(simdiki, birim),
            sayiMetni(onceki, birim),
            yon,
            sayiMetni(sinir, birim),
          ],
        },
      ]}
    >
      <svg
        role="img"
        aria-label={ozetMetni}
        viewBox="0 0 180 32"
        width="100%"
        style={{ display: "block", height: "auto", maxWidth: 180 }}
      >
        <title>{ozetMetni}</title>
        <rect
          x="2"
          y="8"
          width="176"
          height="16"
          rx="4"
          fill="var(--color-notr-100)"
          stroke="var(--color-notr-300)"
        />
        <rect
          data-testid="mini-dolgu"
          x="2"
          y="8"
          width={176 * oran}
          height="16"
          rx="4"
          fill="var(--color-marka-600)"
        />
      </svg>
      <p className="text-notr-800 text-sm">
        <span data-testid="yon-oku" aria-hidden="true">
          {ok}{" "}
        </span>
        {yon} · {sayiMetni(simdiki, birim)}
        {/* Yalın kipte tablo düğmesi yok: önceki değer görünür metinde söylenir. */}
        {yalin && onceki !== null && (
          <span className="text-notr-600"> (önceki {sayiMetni(onceki, birim)})</span>
        )}
      </p>
      {(sinir === null || sinir === 0) && (
        <p className="text-notr-600 text-sm">Üst sınır olmadığı için doluluk gösterilemiyor.</p>
      )}
      {simdiki !== null && sinir !== null && simdiki > sinir && (
        <p className="text-notr-600 text-sm">Değer üst sınırı aşıyor; çubuk tam dolu gösterilir.</p>
      )}
    </GrafikCercevesi>
  );
}
